export enum LanguageDirection {
  LTR = 'ltr',
  RTL = 'rtl',
}
